'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-236/node_modules/@eliadmin/core/src/components/auth/change-password-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-236/node_modules/@eliadmin/core/src/components/auth/change-password-form.tsx").ChangePasswordForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/changePasswordForm").then(m => ({ default: m.ChangePasswordForm })));
export function ChangePasswordForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

